<div>
    <pannel [title]="'Date de l&rsquo;inspection commune pr&eacute;alable (ICP)'" [expandable]="true" >
        <div class="form-group col-sm-12">
            <div class="col-sm-3">
                <label for="dateInspectionCommunePrealable" class="control-label">Date de l&rsquo;ICP &lowast;: </label>
            </div>
            <div [ngClass]="'col-sm-5' + (mandatoryField ? ' highlightable' : '')">
                <date-input [id]="'dateInspectionCommune'" [(localDate)]="dateInspectionCommunePrealable" (localDateChange)="notifyModelChange()"
                	aria-placeholder="Saisissez la date de l&rsquo;ICP" ></date-input>
            </div>
        </div>
    </pannel>
    
    <!-- nouveaux risques -->
    <pannel [title]="'Survenance de nouveau(x) risque(s)'" [expandable]="true" >
        <button type="button"
                class="btn btn-primary"
                (click)="addNouveauRisque()">
            Nouveau Risque
        </button>
        <table mat-table class="nouveauxrisques-table" [dataSource]="nouveauxRisques">
            <!-- Date d’apparition du nouveau risque -->
            <ng-container matColumnDef="dateApparitionNouveauRisque">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Date d&rsquo;apparition du nouveau risque</th>
                <td mat-cell *matCellDef="let nouveauRisque" [ngClass]="mandatoryField ? ' highlightable' : ''">
                    <date-input [id]="'dateApparitionNouveauRisque'" [(localDate)]="nouveauRisque.dateApparitionNouveauRisque" (localDateChange)="notifyModelChange()" >
                    </date-input>
                </td>
            </ng-container>
            <!-- Cause(s) d’apparition : -->
            <ng-container matColumnDef="causeApparition">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Cause(s) d&rsquo;apparition</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <input id="causeApparition" name="causeApparition" class="form-control" [maxLength]="255" (change)="notifyModelChange()"
                           [ngClass]="'form-control' + (mandatoryField ? ' mandatory-field' : '')" [(ngModel)]="nouveauRisque.causeApparition" />
                </td>
            </ng-container>
            <!-- Entreprise(s) concernée(s) :  -->
            <ng-container matColumnDef="entreprisesConcernees">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Entreprise(s) concern&eacute;e(s)</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <div class="input-group" style="width: 100%" *ngFor="let selection of nouveauxRisques.data[nouveauRisque.id - 1].selectedEntreprises; let index = index">
                        <div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
                            <input
                                    type="text"
                                    class="form-control"
                                    [value]="selection.entreprise.nom"
                                    readonly />
                            <div class="input-group-addon">
                                <a href="#" onclick="return false;" (click)="onEntrepriseDeselected(index, nouveauRisque)">
                                    <span class="fa fa-minus-circle fa-lg"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="input-group" style="width: 100%">
                        <div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
                            <filterable-select
                                    [id]="'societe'"
                                    [inputClass]="'form-control'"
                                    [list]="nouveauxRisques.data[nouveauRisque.id - 1].availableEntreprises"
                                    [labelGetter]="getEntrepriseLabel"
                                    [(selectedItem)]="nouveauxRisques.data[nouveauRisque.id - 1].selectedEntreprise"
                                    (selectedItemChange)="onEntrepriseSelected($event, nouveauRisque)"
                            >
                            </filterable-select>
                            <div class="input-group-addon">
                                <a href="#" onclick="return false;">
                                    <span class="fa fa-plus-circle fa-lg"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </td>
            </ng-container>
            <!-- raison sociale -->
            <ng-container matColumnDef="raisonSociale">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Raison sociale</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <div class="col-sm-12 nouveauxrisques-raisonSociale" *ngFor="let selection of nouveauxRisques.data[nouveauRisque.id - 1].selectedEntreprises; let index = index">
                  		<span>{{ getRaisonSociale(selection.entreprise.id) }}</span>
                    </div>
                     <div class="col-sm-12 nouveauxrisques-raisonSociale"><!-- bloc vide --></div>
                </td>
            </ng-container>
            <!-- Nouveau(x) risque(s) identifié(s) -->
            <ng-container matColumnDef="nouveauRisqueIdentifie">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Nouveau(x) risque(s) identifi&eacute;(s)</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <input id="nouveauRisqueIdentifie" name="nouveauRisqueIdentifie" class="form-control" [(ngModel)]="nouveauRisque.nouveauRisqueIdentifie" [maxLength]="255" (change)="notifyModelChange()" />
                </td>
            </ng-container>
            <!-- Mesures de prévention et de protection -->
            <ng-container matColumnDef="mesurePreventionProtection">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Mesures de pr&eacute;vention et de protection</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <input id="mesurePreventionProtection" name="mesurePreventionProtection" class="form-control" [(ngModel)]="nouveauRisque.mesurePreventionProtection" [maxLength]="255" (change)="notifyModelChange()" />
                </td>
            </ng-container>
            <!-- EU  -->
            <ng-container matColumnDef="eu">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>EU</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <mat-checkbox [(ngModel)]="nouveauRisque.eu" color="primary" (change)="notifyModelChange()" ></mat-checkbox>
                </td>
            </ng-container>
            <!-- Responsabilité  -->
            <ng-container matColumnDef="ee">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>EE</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <mat-checkbox [(ngModel)]="nouveauRisque.ee" color="primary" (change)="notifyModelChange()" ></mat-checkbox>
                </td>
            </ng-container>
            <!-- Noms -->
            <ng-container matColumnDef="nomsMesurePrevention">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef>Noms</th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <input id="nomsMesurePrevention" name="nomsMesurePrevention" class="form-control" [(ngModel)]="nouveauRisque.noms" [maxLength]="128" (change)="notifyModelChange()" />
                </td>
            </ng-container>
            <!-- Trash -->
            <ng-container matColumnDef="trashMesurePrevention">
                <th mat-header-cell class="nouveauxrisques-header-cell" *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let nouveauRisque">
                    <i 	class="fa fa-trash fa-2x text-danger" style="margin-left: 12px;" 
                    	(click)="(isUpdateMode && !nouveauRisque.updatable) ? false : removeNouveauRisque(nouveauRisque.id)">
                   	</i>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsNouveauxRisques"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsNouveauxRisques;"></tr>
        </table>
    </pannel>
    
    <!-- bloc validation -->
    <pannel [title]="typePdp === 0 ? 'Validation et émargement du plan de prévention' : 'Validation du plan de prévention'" [expandable]="true" >
        <button type="button" class="btn btn-primary" (click)="addValideurPdp()">
            Nouveau Valideur
        </button>
        <table [ngClass]="valideurSignatairesApplicable() ? 'validateur-table' : 'validateur-libre-table'" >
        	<th>Nom / Pr&eacute;nom du {{ valideurSignatairesApplicable() ? 'signataire' : 'valideur'  }}</th>
        	<th>Entreprise &lowast;</th>
        	<th>Raison sociale</th>
        	<th *ngIf="valideurSignatairesApplicable()">Email</th>
        	<th *ngIf="valideurSignatairesApplicable()">Fonction du signataire</th>
        	<th *ngIf="!valideurSignatairesApplicable()">Fonction du valideur</th>
        	<th>{{ libelleColonneValideur() }}</th>
        	<th></th>
        	<ng-container [ngTemplateOutlet]="valideurSignatairesApplicable() ? blocValideurIntervenant : blocValideurLibre"></ng-container>
        </table>
    </pannel>
    <!-- bloc signataires, representants et intervenants -->
	<ng-container [ngTemplateOutlet]="valideurSignatairesApplicable() ? blocSignatairesAvecRepresentants : blocSignatairesOuIntervenants"></ng-container>
</div>

<!-- popup gestion des referents -->
<signataire-dialog [id]="'gererRepresentantsInStepFinalisation'" [initCommands]="gererRepresentantsCommands" (signatairesSelected)="onRepresentantsSelected($event)"></signataire-dialog>

<!-- popup gestion des intervenants -->
<signataire-dialog [id]="'gererIntervenantsInStepFinalisation'" [initCommands]="gererIntervenantsCommands" (signatairesSelected)="onIntervenantsSelected($event)"></signataire-dialog>

<!-- different templates -->

<ng-template #blocSignatairesAvecRepresentants>
	<pannel [title]="'Signataires'" [expandable]="true" >
		<ng-container [ngTemplateOutlet]="blocRepresentant"></ng-container>
		<ng-container [ngTemplateOutlet]="blocSignatairesOuIntervenants"></ng-container>
	</pannel>
</ng-template>

<ng-template #blocRepresentant>
	<pannel [title]="'Représentants'" [expandable]="true" >
        <div style="display: inline-flex">
            <button type="button" class="btn btn-primary" (click)="openDialogRepresentants()">
            	Ajouter Représentant
            </button>
            <select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForRepresentantDialog">
                <option [ngValue]="null"></option>
                <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
            </select>
        </div>
	<table mat-table class="representants-table" [dataSource]="representants">
	    <!-- Nom -->
	    <ng-container matColumnDef="nom">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Nom</th>
	        <td mat-cell *matCellDef="let representant">
	            {{ representant.nom }}
	        </td>
	    </ng-container>
	    <!-- Prénom -->
	    <ng-container matColumnDef="prenom">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Prénom</th>
	        <td mat-cell *matCellDef="let representant">
	            {{ representant.prenom }}
	        </td>
	    </ng-container>
	    <!-- Entreprise -->
	    <ng-container matColumnDef="entreprise">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Entreprise</th>
	        <td mat-cell *matCellDef="let representant">
	            {{ representant.nomEntreprise }}
	        </td>
	    </ng-container>
	    <ng-container matColumnDef="raisonSociale">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Raison Sociale</th>
	        <td mat-cell *matCellDef="let representant">
	            {{ representant.raisonSociale }}
	        </td>
	    </ng-container>
	    <!-- Email -->
	    <ng-container matColumnDef="email">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Email</th>
	        <td mat-cell *matCellDef="let representant">
	            <input id="emailRepresentant" name="emailRepresentant" (focusout)="onFocusLeaveEmailRepresentant(representant)" 
	            class="form-control {{ representant.emailStyle }}" [(ngModel)]="representant.email" >
	        </td>
	    </ng-container>
	    <!-- isIntervenant -->
	    <ng-container matColumnDef="isIntervenant">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Intervenant ?</th>
	        <td mat-cell *matCellDef="let representant; let i = index;">
	            <mat-checkbox [(ngModel)]="representant.isIntervenant" color="primary" (change)="onChangeChoixIntervenant(representant, i)"></mat-checkbox>
	        </td>
	    </ng-container>
	    <!-- Fonction -->
	    <ng-container matColumnDef="fonction">
	        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Fonction</th>
	        <td mat-cell *matCellDef="let representant">
	            <input id="fonctionRepresentant" name="fonctionRepresentant" (change)="notifyModelChange()" class="form-control" [(ngModel)]="representant.fonction" >
	        </td>
	    </ng-container>
	    <tr mat-header-row *matHeaderRowDef="displayedColumnsRepresentants"></tr>
	    <tr mat-row *matRowDef="let row; columns: displayedColumnsRepresentants"></tr>
	</table>
	</pannel>
</ng-template>

<ng-template #choixAllEntreprisesEUEE>
	<select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForIntervenantDialog">
	    <option [ngValue]="null"></option>
	    <option *ngFor="let entrepriseTLR of entreprisesValideurs" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
	</select>
</ng-template>

<ng-template #choixEntreprisesEE>
	<select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForIntervenantDialog">
	    <option [ngValue]="null"></option>
	    <option *ngFor="let entrepriseTLR of entreprises" [ngValue]="entrepriseTLR">{{entrepriseTLR.nom}}</option>
	</select>
</ng-template>

<ng-template #blocSignatairesOuIntervenants>
    <pannel [title]="typePdp === 0 ? 'Liste des intervenants' : 'Tableau d&rsquo;&eacute;margement du plan de pr&eacute;vention par les intervenants'" [expandable]="true" >
        <div style="display: inline-flex">
            <button type="button" class="btn btn-primary" (click)="openDialogIntervenants()">
            	Ajouter {{ valideurSignatairesApplicable() ? 'Intervenant' : 'Signataire'  }}
            </button>
            <ng-container [ngTemplateOutlet]="choixAllEntreprisesEUEE"></ng-container>
        </div>
        <table mat-table class="signataires-table" [dataSource]="signataires">
            <!-- Nom -->
            <ng-container matColumnDef="nom">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>{{ typePdp === 0 ? 'Nom' : 'Nom du signataire' }}</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.nom}}
                </td>
            </ng-container>
            <!-- Prénom -->
            <ng-container matColumnDef="prenom">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>{{ typePdp === 0 ? 'Pr&eacute;nom' : 'Pr&eacute;nom du signataire' }}</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.prenom}}
                </td>
            </ng-container>
            <!-- Entreprise -->
            <ng-container matColumnDef="entreprise">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Entreprise</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.nomEntreprise}}
                </td>
            </ng-container>
            <ng-container matColumnDef="raisonSociale">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Raison Sociale</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.raisonSociale}}
                </td>
            </ng-container>
		    <!-- Email -->
		    <ng-container matColumnDef="email">
		        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Email</th>
		        <td mat-cell *matCellDef="let signataire">
		            <input id="emailSignataire" name="emailSignataire" (focusout)="onFocusLeaveEmailIntervenant(signataire)"
		            class="form-control {{ signataire.emailStyle }}" [(ngModel)]="signataire.email" >
		        </td>
		    </ng-container>
            <!-- Fonction -->
            <ng-container matColumnDef="fonction">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>{{ typePdp === 0 ? 'Fonction' : 'Fonction du signataire' }}</th>
                <td mat-cell *matCellDef="let signataire">
                    <input id="fonctionSignataire" name="fonctionSignataire" (change)="notifyModelChange()" class="form-control" [(ngModel)]="signataire.fonction" >
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsSignataires"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSignataires"></tr>
        </table>
    </pannel>
</ng-template>

<ng-template #blocValideurLibre>
	<tr *ngFor="let valideur of valideurs; let index = index">
		<td>
			<input id="nomPrenomValidateur" name="nomPrenomValidateur" [maxLength]="100" (change)="notifyModelChange()"
	               [ngClass]="'form-control' + (mandatoryField ? ' mandatory-field' : '')" [(ngModel)]="valideur.nomPrenomValidateur">
		</td>
	    <td>
	        <select class="form-control" [ngClass]="'form-control' + (mandatoryField ? ' highlightable' : '')"
	                [(ngModel)]="selectedEntrepriseIds[index]" (change)="onSelectEntrepriseValideur(index)">
	            <option [ngValue]="null" disabled></option>
	            <option *ngFor="let entrepriseTLR of entreprisesValideurs" [ngValue]="entrepriseTLR.id">{{entrepriseTLR.nom}}</option>
	        </select>
	    </td>
	    <td>{{ valideur.raisonSociale }}</td>
		<td>
			<input id="fonctionValidateur" name="fonctionValidateur" class="form-control" [(ngModel)]="valideur.fonctionValidateur" [maxLength]="100" (change)="notifyModelChange()">
		</td>
	    <td>
	        <date-input [id]="'dateValidation'" [(localDate)]="valideur.dateValidation" (localDateChange)="notifyModelChange()"></date-input>
	    </td>
		<!-- Trash -->
	  	<td>
			<i class="fa fa-trash fa-2x text-danger" style="margin-left: 12px;" (click)="(isUpdateMode && !valideur.updatable) ? false : removeValideur(valideur.id, index)"></i>
		</td>
	</tr>
</ng-template>

<ng-template #blocValideurIntervenant>
	<tr *ngFor="let valideur of valideurSignataires; let index = index">
		<td>
			<filterable-select
				[inputClass]="'form-control' + (mandatoryField ? ' highlightable' : '')"
				[list]="displayableSignataires[index]"
				[labelGetter]="getIntervenantLabel"
				(selectedItemChange)="onValideurSelected($event, index)"
				[(selectedItem)]="selectedValideurs[index]" >
			</filterable-select>
		</td>
	    <td>
	        <select class="form-control" [ngClass]="'form-control' + (mandatoryField ? ' highlightable' : '')"
	                [(ngModel)]="selectedEntrepriseIds[index]" (change)="onSelectEntrepriseValideurSignataire(index)">
	            <option [ngValue]="null" disabled></option>
	            <option *ngFor="let entrepriseTLR of entreprisesValideurs" [ngValue]="entrepriseTLR.id">{{entrepriseTLR.nom}}</option>
	        </select>
	    </td>
	    <td>{{ valideur.raisonSociale }}</td>
		<td>
			<input id="emailValideur" name="emailValideur" class="form-control {{ valideur.emailStyle }}" 
				(focusout)="onFocusLeaveEmailValideurSignataire(valideur)" [(ngModel)]="valideur.email" >
		</td>
		<td>
			<input id="fonctionSignataire" name="fonctionSignataire" class="form-control" [(ngModel)]="valideur.fonction" [maxLength]="255" (change)="notifyModelChange()">
		</td>
	    <td class="choixTypeValideur">
	        <select class="form-control" [ngClass]="'form-control'" [(ngModel)]="valideur.typeValideur" (change)="onChangeTypeValideur(selectedValideurs[index], valideur, index)" >
	            <option [ngValue]="null" disabled></option>
	            <option *ngFor="let typeValideur of suggestableTypeValideurs(valideur)" [ngValue]="typeValideur.code">{{ typeValideur.label }}</option>
	        </select>
	    </td>
		<!-- Trash -->
	  	<td>
			<i class="fa fa-trash fa-2x text-danger" style="margin-left: 12px;" (click)="(isUpdateMode && !valideur.updatable) ? false : removeValideur(valideur.id, index)"></i>
		</td>
	</tr>
</ng-template>

